import { Navigate } from "react-router-dom"
import { useAuth } from "@/contexts/AuthContext"

export function RedirectToApp() {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-background">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    )
  }

  return <Navigate to={user ? "/chat" : "/login"} replace />
}
